import { render } from "./award.vue?vue&type=template&id=8accdb50&scoped=true"
import script from "./award.vue?vue&type=script&lang=js"
export * from "./award.vue?vue&type=script&lang=js"

import "./award.vue?vue&type=style&index=0&id=8accdb50&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8accdb50"]])

export default __exports__